import { CommonModule } from "@angular/common";
import { Component, input, output } from "@angular/core";
import { AudioExercise as AudioExerciseComponent } from "@components/audio-exercise/audio-exercise";
import { DropDownExercise as DropDownExerciseComponent } from "@components/drop-down-exercise/drop-down-exercise";
import { Answer } from "@domain/Answer";
import { DropDownExercise, Exercise as ExerciseEntity, AudioExercise } from "@domain/Exercise";

@Component({
  selector: "app-exercise",
  imports: [CommonModule, DropDownExerciseComponent, AudioExerciseComponent],
  template: `
    @if (getDropDownExercise(); as exercise) {
      <app-drop-down-exercise [exercise]="exercise" [answer]="answer()" (selectAnswer)="updateAnswer.emit($event)" />
    }
    @if (getAudioExercise(); as exercise) {
      <app-audio-exercise [exercise]="exercise" [answer]="answer()" (updateAnswer)="updateAnswer.emit($event)" (playAudio)="playAudio.emit()" />
    }
  `,
})
export class Exercise {
  exercise = input.required<ExerciseEntity>();
  answer = input.required<Answer | undefined>();

  updateAnswer = output<Answer | undefined>();
  playAudio = output<void>();

  getDropDownExercise() {
    const exercise = this.exercise();

    if (!(exercise instanceof DropDownExercise)) return undefined;

    return exercise;
  }

  getAudioExercise() {
    const exercise = this.exercise();

    if (!(exercise instanceof AudioExercise)) return undefined;

    return exercise;
  }
}
